export default __webpack_public_path__ + "static/media/Q.7cb86295.mp3";